import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UiLoadingProps {
  text: string;
}
interface UIProps {
  loading: UiLoadingProps | null;
  lateralMenuStatus: boolean;
}

const initialState: UIProps = {
  loading: null,
  lateralMenuStatus: false,
};

const UISlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openLoading: (state, action: PayloadAction<{ text: string } | null>) => {
      state.loading = { text: action?.payload?.text || "" };
    },
    closeLoading: (state) => {
      state.loading = null;
    },
    changeLateralMenuSatus: (state, action: PayloadAction<boolean | null>) => {
      state.lateralMenuStatus = action.payload || false;
    },
  },
});

export const { openLoading, closeLoading, changeLateralMenuSatus } =
  UISlice.actions;

export default UISlice.reducer;
